import { defineMessages, useIntl } from 'react-intl';
import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';
import { BodyText, LoadingDots } from '@garnish/core';

// ─────────────────────────────────────────────────────────────────────────────

export const AddToBagLoading = () => {
  const { formatMessage } = useIntl();

  return (
    <View style={styles.container}>
      <View style={styles.circle}>
        <LoadingDots color={theme.colors.WHITE} />
      </View>

      <BodyText sizeMatch={['16']} style={styles.text}>
        {formatMessage(messages.addingToBag)}
      </BodyText>
    </View>
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

const CIRCLE_SIZE = 64;

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    gap: theme.spacing['6'],
    paddingVertical: theme.spacing['10'],
  },
  circle: {
    width: CIRCLE_SIZE,
    height: CIRCLE_SIZE,
    borderRadius: CIRCLE_SIZE / 2,
    backgroundColor: theme.colors.KALE,
    alignItems: 'center',
    justifyContent: 'center',
  },
  text: {
    textAlign: 'center',
  },
});

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  addingToBag: {
    defaultMessage: 'Adding to your bag…',
    description: 'Add To Bag | Loading | Adding to bag message',
  },
});
